<template>
  <div class="inventory-adjustment">
    <!-- 搜索 S -->
    <search-panel :ref-obj.sync="searchFormInfo.ref"
                  :data="searchFormInfo.data"
                  :fileList="searchFieldList"
                  :labelWidth="searchFormInfo.labelWidth"
                  :ruleList="searchFormInfo.rules"
                  style="white-space: nowrap;"
                  :handleChange="() => false"
                  :search="() => getList(1)">
                  <template v-slot:form-warehouseCode>
                    <warehouse-select style="width: 200px !important" ref="warehouseSelect" :warehouseCode.sync="searchFormInfo.data.warehouseCode"></warehouse-select>
                  </template>
                  </search-panel>
    <!-- 搜索 E -->
    <!-- 列表 S -->
    <page-table ref='pageTable'
                :refresh="refresh"
                permission="labelCost"
                :list="adjustmentList"
                :fieldList="fieldList"
                :page="page"
                :size="size"
                handelWidth='150'>
      <template v-slot:col-ysdGoodsType="scope">
        <span>{{ scope.row.ysdGoodsType===0 ? '正常品' : '破损品' }} </span>
      </template>
      <template v-slot:col-ysdHandleNum="scope">
        <span :class="redOrGreen(scope.row.ysdHandleNum)">{{ scope.row.ysdHandleNum }} </span>
      </template>
      <template v-slot:col-ysdSourceType="scope">
        <span v-if="scope.row.ysdSourceType == 0">盘点损益</span>
      </template>
      <template v-slot:col-yilCode="scope">
        <el-button class="text-blue" type="text" size="small" @click="$router.push('/liquidationManage/liquidationLossDetail/' + scope.row.yilCode + '/' + searchFormInfo.data.warehouseCode)">{{ scope.row.yilCode }}</el-button>
      </template>
      <template v-slot:col-ysdProductionTime="scope">
        <span v-if="scope.row.ysdFinishOpenStatus == 0">-</span>
        <span v-else>{{scope.row.ysdProductionTime || '无'}}</span>
      </template>
    </page-table>
    <!-- 列表 E -->
  </div>
</template>

<script>
import searchPanel from '@/components/Table/SearchPanel'
import pageTable from '@/components/Table/Index'
import inventoryManage from '@/store/inventoryManage/index.js'
import { GETSTOCKADJUSTPAGE } from '@/store/inventoryManage/types.js'
import WarehouseSelect from '@/components/WarehouseSelect.vue'
export default {
  name: 'inventoryAdjustment',
  components: {
    pageTable,
    searchPanel,
    WarehouseSelect
  },
  data () {
    return {
      sum: 0,
      // 搜索框
      searchFormInfo: {
        ref: null,
        data: {
          handleStartTime: [],
          warehouseCode: ''
        },
        rules: {},
        labelWidth: '90px'
      },
      size: 10,
      page: 1,
      fieldList: [
        { label: '商品名称', prop: 'goodsName', width: 170, align: 'center' },
        { label: '生产日期', prop: 'ysdProductionTime', width: 100, type: 'slot', align: 'center' },
        { label: '品质', prop: 'ysdGoodsType', width: 90, type: 'slot', align: 'center' },
        { label: '货位编码', prop: 'ylCode', width: 145, align: 'center' },
        { label: '调整数量(件)', prop: 'ysdHandleNum', width: 90, type: 'slot', align: 'center' },
        { label: '供应商', prop: 'supplierName', width: 170, align: 'center' },
        { label: '商品编码', prop: 'goodsCode', width: 145, align: 'center' },
        { label: '商品条码', prop: 'barCode', width: 145, align: 'center' },
        { label: '来源类型', prop: 'ysdSourceType', width: 100, type: 'slot', align: 'center' },
        { label: '关联单号', prop: 'yilCode', width: 145, type: 'slot', align: 'center' },
        { label: '操作人', prop: 'ysdHandleName', width: 100, align: 'center' },
        { label: '调整时间', prop: 'ysdHandleTime', width: 160, align: 'center' }
      ]
    }
  },
  filters: {
    toFixed (val) {
      if (val != null) {
        return val.toFixed(2)
      }
    }
  },
  computed: {
    // 搜索框
    searchFieldList () {
      return [
        { label: '仓库名称', prop: 'warehouseCode', type: 'slot', labelWidth: '90px' },
        {label: '商品名称', prop: 'goodsName', type: 'input', labelWidth: '90px'},
        {label: '供应商', prop: 'supplierName', type: 'input', labelWidth: '80px'},
        {label: '商品品质', prop: 'ysdGoodsType', type: 'select', options: this.qualitySelect, labelWidth: '80px'},
        {label: '商品编码', prop: 'goodsCode', type: 'input', labelWidth: '90px'},
        {label: '商品条码(69码)', prop: 'barCode', type: 'input', labelWidth: '120px'},
        {label: '关联单号', prop: 'yilCode', type: 'input', labelWidth: '90px'},
        {label: '调整时间', prop: 'handleStartTime', type: 'datePickerRange', labelWidth: '90px'}
      ]
    },
    // 下拉框 - 商品品质
    qualitySelect () {
      return [
        {label: '全部', value: ''},
        {label: '正常品', value: 0},
        {label: '破损品', value: 1}
      ]
    },
    // 列表
    adjustmentList () {
      return inventoryManage.state.adjustmentList
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 分页刷新
    refresh (page, size) {
      this.page = page
      this.size = size
      this.getList()
    },
    // 请求数据列表
    getList () {
      let {supplierName, goodsName, ysdGoodsType, goodsCode, barCode, yilCode, handleStartTime, warehouseCode} = this.searchFormInfo.data
      let params = {
        page: this.page,
        rows: this.size,
        supplierName,
        goodsName,
        ysdGoodsType,
        goodsCode,
        barCode,
        yilCode,
        warehouseCode,
        handleStartTime: handleStartTime && handleStartTime.length ? handleStartTime[0] + ' 00:00:00' : '',
        handleEndTime: handleStartTime && handleStartTime.length ? handleStartTime[1] + ' 23:59:59' : ''
      }
      this.$store.dispatch(GETSTOCKADJUSTPAGE, params)
    },
    // 库存差异 文字颜色
    redOrGreen (val) {
      if (!val || val === '0') return ''
      if (parseInt(val) > 0) return 'status-close'
      return 'status-open'
    }
  }
}
</script>

<style scoped>
.text-blue >>> span{
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/page/inventoryManage/InventoryAdjustment.vue